/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.$ = window.jQuery = require('jquery');

//region Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

var token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
//endregion

window.Popper = require('popper.js').default;

require('bootstrap');

window.sortable = require('jquery-ui/sortable');


window.tagsinput = require('bootstrap-tagsinput');

window.urlify = require('urlify').create();

window.store = require('store');

window.toastr = require('toastr');

window.moment = require('moment');


// WEBPACK FOOTER //
// ./resources/assets/js/app.js